import Button from "../Atoms/Button";
import AlternativeButton from "../Atoms/AlternativeButton";
import { useAppSelector } from "Redux/hooks";
import { ReactNode } from "react";
import { leanEntries } from "Constants/defaultStyles";
import { selectStyle } from "Redux/appSlice";

type Props = {
  text: string | ReactNode;
  onContinue: () => void;
  onCancel: () => void;
};

export default function PopUp({ text, onContinue, onCancel }: Props) {
  const { color1 } = useAppSelector(selectStyle);
  return (
    <div className="absolute h-full w-full bg-black/80 z-50">
      <div
        style={{ background: leanEntries.color2 }}
        className="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 rounded-lg p-8"
      >
        <div className="text-center pb-8" style={{ color: color1 }}>
          {text}
        </div>
        <div className="flex justify-between">
          <Button
            className="m-2"
            id="continueButton"
            onClick={onContinue}
            label="continue"
          />
          <div className="inline m-2">
            <AlternativeButton
              id="cancelButton"
              onClick={onCancel}
              label="cancel"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
